import Component from 'vue-class-component';
import { Language } from '../enums/Language';
import { BaseStore } from './base.store';

@Component
export class LangStore extends BaseStore {
	protected readonly localeMap: { [key in Language]: string } = {
		[Language.Cz]: "cs-CZ",
		[Language.Ru]: "ru-RU",
		[Language.En]: "en-US",
		[Language.De]: "de-DE",
		[Language.Ua]: "ua-UA",
		[Language.Su]: "su-SU",
	};

	langId: Language = null;

	getLocale() {
		//nastaveni ruske jv na cz
		this.langId = this.langId === 2 ? 1 : this.langId;
		return this.localeMap[this.langId];
	}

	setLang(langId: Language) {
		this.langId = langId;
		this.$cookiesService.jv = langId;
	}

	fetchLang() {
		let jv = parseInt(this.$route.query.jv);

		//nastaveni ruske jv na cz
		jv = jv === 2 ? 1 : jv;

		if (window.location.href.match("central-group.ru")) {
			//jv = Language.Ru;
			jv = Language.Cz;
		}

		if (this.localeMap[jv as Language]) {
			this.setLang(jv);
		} else {
			this.langId = this.$cookiesService.jv || Language.Cz;
		}
	}
}
